module.exports = __webpack_public_path__ + "email_icon_32x32.0cb4fb533b8051c6bbef.png";


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/assets/images/email_icon_32x32.png
// module id = ../../../../../src/assets/images/email_icon_32x32.png
// module chunks = styles